import { isGlobalProject } from 'config';
import { useTranslation } from 'libs/i18n';
import { OnboardingPepConnection } from 'modules/onboarding/common/components';

import { usePepConnection } from '../hooks';
import { useOnboardingContext } from '../hooks/useOnboardingContext';
import { PageComponentProps } from '../types';

export const PepConnectionStep = ({ canGoBack }: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading } =
    usePepConnection();

  const { step } = useOnboardingContext();

  const { t } = useTranslation();

  return (
    <OnboardingPepConnection
      canGoBack={canGoBack}
      initialValues={initialValues}
      notRequestInformation={isGlobalProject()}
      positionPlaceholder={t(
        'onboarding.legalClientBeneficiary.pepConnection.position.placeholder'
      )}
      relationLabel={t(
        'onboarding.legalClientBeneficiary.pepConnection.relation.label'
      )}
      step={step}
      submitLoading={submitLoading}
      subTitle={t('onboarding.legalClientBeneficiary.pepConnection.subtitle')}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
